import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { ExternalProviderRepository } from "@shared-kernel/application/ports/external-provider/external-provider-repository";

interface UploadExternalProviderInvoiceCommand {
  file: File;
  externalProviderRepository: ExternalProviderRepository;
}

export const uploadExternalProviderInvoice = createAsyncThunk<string, UploadExternalProviderInvoiceCommand>(
  "externalProvider/uploadInvoice",
  async ({ file, externalProviderRepository }: UploadExternalProviderInvoiceCommand) => {
    return externalProviderRepository.uploadInvoice(file);
  },
);

export const resetUploadExternalProviderInvoice = createAction("externalProvider/resetUploadInvoice");
